//
//
//
//
//
//
//
export default {
  components: {},
  mixins: [],
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};